const ShareHook = {
  mounted() {
    if (!navigator.share) {
      return;
    }

    this.el.removeAttribute('hidden');
    const data = {
      url: this.el.dataset.url,
      text: this.el.dataset.text,
      title: this.el.dataset.title,
    };

    this.el.addEventListener('click', () => {
      try {
        navigator.share(data);
      } catch (e) {
        console.log('Share failed', e);
      }
    });
  },
};

export default ShareHook;
